import { render, staticRenderFns } from "./ModalEditCartData.vue?vue&type=template&id=74640170"
import script from "./ModalEditCartData.vue?vue&type=script&lang=js"
export * from "./ModalEditCartData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports